<template>
  <div :class="`${wrapper}__slider`">
    <div :class="`${wrapper}__slider-wrap`">
      <div :class="`${wrapper}__slider-track`">
        <slot></slot>
      </div>
    </div>
    <button :class="`${wrapper}__button ${wrapper}__button_prev`">
      <img src="@/assets/images/svg-defs/arrow-left-aux.svg" alt />
    </button>
    <button :class="`${wrapper}__button ${wrapper}__button_next`">
      <img src="@/assets/images/svg-defs/arrow-right-aux.svg" alt />
    </button>
  </div>
</template>

<script>
import Slider from "@/plugins/slider.plugin";

export default {
  name: "Slider",
  props: {
    wrapper: String
  },
  data: () => ({
    slider: null
  }),
  mounted() {
    this.slider = new Slider(`.${this.wrapper}__slider`, {
      buttons: {
        prev: `.${this.wrapper}__button_prev`,
        next: `.${this.wrapper}__button_next`
      },
      slides: {
        slidesToShow: 1,
        slidesToScroll: 1
      },
      slide: `.${this.wrapper}__slide`,
      track: `.${this.wrapper}__slider-track`
    });
  },
  beforeDestroy() {
    this.slider && this.slider.destroy ? this.slider.destroy() : null;
  }
};
</script>
